import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import { EffectCoverflow, Pagination } from 'swiper/modules'
import email1 from '@/public/pages/email-marketing/email-1.png'
import email2 from '@/public/pages/email-marketing/email-2.png'
import email3 from '@/public/pages/email-marketing/email-3.jpg'
import email4 from '@/public/pages/email-marketing/email-4.png'
import email5 from '@/public/pages/email-marketing/email-5.jpg'
import email6 from '@/public/pages/email-marketing/email-6.png'
import email from '@/public/pages/email-marketing/spf-2025-08-aug-email-long-4.jpg'

export default function WorkGallery() {
  return (
    <Swiper
      effect="coverflow"
      grabCursor={true}
      loop={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      centeredSlides={true}
      slidesPerView={3}
      slidesPerGroup={1}
      spaceBetween={0}
      coverflowEffect={{
        rotate: 50,
        stretch: 0,
        depth: 200,
        modifier: 1,
        slideShadows: true,
      }}
      modules={[EffectCoverflow, Pagination]}
      className="w-full"
    >
      {[email, email1, email2, email3, email4, email5, email6].map(
        (src, index) => (
          <SwiperSlide
            key={`email-slide-${index}-${src.src || index}`}
            className="w-full overflow-hidden rounded-3xl border shadow-lg"
          >
            <Image
              src={src}
              alt={`Email Marketing Example ${index + 1}`}
              sizes="(min-width: 1280px) 411px, calc((100vw - 48px) / 3)"
              className="h-auto max-h-[300px] w-full object-contain object-top lg:max-h-[800px]"
            />
          </SwiperSlide>
        ),
      )}
    </Swiper>
  )
}
